import { render, staticRenderFns } from "./TopicMore.vue?vue&type=template&id=3bb26527&"
import script from "./TopicMore.vue?vue&type=script&lang=js&"
export * from "./TopicMore.vue?vue&type=script&lang=js&"
import style0 from "./TopicMore.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports